<template>
    <dash
        icon="fa fa-dollar"
        titulo="PAGAMENTOS DESPESA"
        subTitulo="FINANCEIRO"
        @click.native="$router.push({ name: 'DespesasGerais_Financeiro_Pagamentos' })"
        :qtd="qtd"
        :qtd2="qtd2"
        :mostrarQtd="true"
        :mostrarQtd2="true"
        :loading="loading"
    ></dash>
</template>

<script>
import Dash from '@/shared/components/DashComponent'

export default {
    props: {
        qtd: {
            type: Number
        },

        qtd2: {
            type: Number
        },

        loading: {
            type: Boolean
        }
    },

    components: {
        Dash
    },

    data() {
        return {}
    }
}
</script>